import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const GiftIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M15.9817 10V17.4774H4.01782V10"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.4773 6.26132H2.52246V10H17.4773V6.26132Z"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99976 17.4774V6.26132"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0001 6.26129H6.63522C6.13944 6.26129 5.66396 6.06434 5.31339 5.71377C4.96282 5.3632 4.76587 4.88772 4.76587 4.39194C4.76587 3.89615 4.96282 3.42068 5.31339 3.0701C5.66396 2.71953 6.13944 2.52258 6.63522 2.52258C9.25232 2.52258 10.0001 6.26129 10.0001 6.26129Z"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99976 6.26129H13.3646C13.8604 6.26129 14.3359 6.06434 14.6864 5.71377C15.037 5.3632 15.2339 4.88772 15.2339 4.39194C15.2339 3.89615 15.037 3.42068 14.6864 3.0701C14.3359 2.71953 13.8604 2.52258 13.3646 2.52258C10.7475 2.52258 9.99976 6.26129 9.99976 6.26129Z"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
